import {API, client} from '@/services/http'

class Statuses {
  constructor () {
    this.statuses = {}
    this.data
  }

  askStatuses () {
    client.get(`${API.BUYOUTS.STATUSES}`)
    .then(data => this.data = data.statuses)
  }

  getStatuses () {
    this.data?.forEach(elem => {
      this.statuses[elem.id] = elem;
    });
    return this.statuses
  }

  getSourceStatuses(sourceId) {
    if(sourceId) {
      return client.get(`${API.BUYOUTS.STATUSES}?sourceId=${sourceId}`)
    }
  }

  getStatusesMinimalSum() {
    return ['progress', 'stop', 'purchasing', 'waitBill', 'receptPrepayments', 'receptPayments', 'receptPostOrders'];
  }
}

export default new Statuses
